import React from 'react'

const Close = ({ height = 13, width = 13, gray }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 13"
    >
      <path
        fill={gray ? '#A1A9B4' : '#fe5054'}
        d="M6.5,0A6.5,6.5,0,1,0,13,6.5,6.5,6.5,0,0,0,6.5,0ZM8.748,9.719,6.5,7.5,4.274,9.75l-.993-.993L5.5,6.505,3.25,4.274l.993-.993L6.494,5.5,8.718,3.25l1,1L7.5,6.495,9.75,8.718Z"
      />
    </svg>
  )
}

export default Close
